import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';
import UIAssetKeys from '../../UIAssetKeys.js';

export default class Popup extends AContainer {
  constructor(scene, type) {
    super(scene);

    this.type = type;

    this.createShader();
    this.initPopup();
  }

  initPopup() {
    if (this.type === 'end') {
      this.bg = this.scene.addImage(0, 0, UIAssetKeys._Cmn_EndBG, this.scene.defaultAtlas, this);
      this.home = this.scene.addButton(90, 210, UIAssetKeys._Cmn_Btn_Home, {}, () => {this.tweenOutPopup('home');}, this);
      this.exit = this.scene.addButton(-110, 210, UIAssetKeys._Cmn_Btn_Retry, {}, () => {this.tweenOutPopup('reset');}, this);

      this.gj = this.scene.addText(-10, -270, 85, '0xffe552', FontKeys._Quicksand, ABCyaPhaser.Localization.instance.getLocalizedString("results_popup.great_job"), this);
      ABCyaPhaser.Text.resizeFontToFitWidth(this.gj, this.bg.getBounds().width - 75, 100, 85);
      this.gj.setScale(0, 0);
      this.gj.setAlpha(0);

      const youSolvedItText = ABCyaPhaser.Localization.instance.getLocalizedString("results_popup.moves_information");
      const parts = youSolvedItText.split("~");

      this.scene.addText(-10, -205, 40, '0xFFFFFF', FontKeys._Quicksand, parts[0].trim(), this);
      this.txt = this.scene.addText(-10, -135, 85, '0xffe552', FontKeys._Quicksand, gameData.moves, this);
      this.scene.addText(-10, -60, 40, '0xFFFFFF', FontKeys._Quicksand, parts[1].trim(), this);
      this.scene.addText(-10, 10, 40, '0xFFFFFF', FontKeys._Quicksand, ABCyaPhaser.Localization.instance.getLocalizedString("results_popup.best_score_label"), this);
      const moves = this.scene.addText(-10, 65, 65, '0xFFFFFF', FontKeys._Quicksand, `${gameData.bestMoves} ${ABCyaPhaser.Localization.instance.getLocalizedString("results_popup.moves")}`, this);
      ABCyaPhaser.Text.resizeFontToFitWidth(moves, this.bg.getBounds().width - 75, 100, 85);

      this.starFire();
    }
    else if (this.type === 'instruct') {
      this.bg = this.scene.addImage(0, 0, UIAssetKeys._pauseBG, this.scene.defaultAtlas, this);
      this.home = this.scene.addButton(0, 70, UIAssetKeys._Btn_Play, {}, () => {this.tweenOutPopup('play');}, this);

      this.txt = this.scene.addText(-10, -100, 34, '0xc7e9f9', FontKeys._Quicksand, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.instructions"), this);
      this.txt.setWordWrapWidth(this.bg.width - 75);
    }
    else {
      this.bg = this.scene.addImage(0, 0, UIAssetKeys._pauseBG, this.scene.defaultAtlas, this);
      this.home = this.scene.addButton(-180, 70, UIAssetKeys._Cmn_Btn_Home, {}, () => {this.tweenOutPopup('home');}, this);
      this.exit = this.scene.addButton(160, 70, UIAssetKeys._Cmn_Btn_Cancl, {}, () => {this.tweenOutPopup('resume');}, this);

      this.soundBG = this.scene.addImage(-10, 70, UIAssetKeys._Cmn_Btn_MuteBG, this.scene.defaultAtlas, this);
      this.soundBtn = this.scene.addButton(-10, 70, UIAssetKeys._Cmn_Btn_SndOn, {}, () => {this.toggleMute();}, this);
      this.mute = this.scene.addButton(-11, 70, UIAssetKeys._Cmn_Btn_SndOff, {}, () => {this.toggleMute();}, this);

      this.txt = this.scene.addText(-10, -100, 34, '0xc7e9f9', FontKeys._Quicksand, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.instructions"), this);
      this.txt.setWordWrapWidth(this.bg.width - 75);

      if (gameData.gameMuted) {
        this.soundBtn.visible = 0;
      }
      else {
        this.mute.visible = 0;
      }
    }

    this.disablePopup();

    this.setPosition(this.scene.mid.x, this.scene.mid.y);
    this.setScale(0, 0);
    this.setDepth(20);

    this.tweenInPopup();
  }

  createShader() {
    const rect = new Phaser.Geom.Rectangle(0, 0, this.scene.mid.x * 2, this.scene.mid.y * 2);
    this.shader = this.scene.add.graphics({ fillStyle: { color: 0x000000 } });
    this.shader.fillRectShape(rect);
    this.shader.setDepth(10);

    this.shader.alpha = 0;
  }

  toggleMute() {
    // console.log(gameData.gameMuted);
    this.scene.playSound('click');

    if (!gameData.gameMuted) {
      // console.log("muting");
      this.scene.sound.setVolume(0);

      this.mute.visible = true;
      this.soundBtn.visible = false;

      this.mute.setEnabled(true);
      this.soundBtn.setEnabled(false);

      gameData.gameMuted = true;
    }
    else {
      // console.log("unmuting");
      this.scene.sound.setVolume(1);

      this.mute.visible = false;
      this.soundBtn.visible = true;

      this.soundBtn.setEnabled(true);
      this.mute.setEnabled(false);

      gameData.gameMuted = false;
    }
  }

  tweenInPopup() {
    this.scene.playSound('theme_exit');

    if (this.type === 'end') {
      this.scene.playSound('great_job');

      this.scene.addTween(this.gj, 500, { alpha: 1, delay: 400 }, Phaser.Math.Easing.Linear);
      this.scene.addTween(this.gj, 1000, { scaleX: 1, scaleY: 1, delay: 400 }, Phaser.Math.Easing.Back.Out);
    }

    this.scene.addTween(this.shader, 500, { alpha: .66 }, Phaser.Math.Easing.Linear);
    this.scene.addTween(
      this,
      1000,
      { scaleX: 1, scaleY: 1 },
      Phaser.Math.Easing.Back.Out,
      () => {this.enablePopup();}
    );
  }

  tweenOutPopup(type) {
    this.scene.playSound('click');
    this.scene.playSound('theme_exit');

    this.disablePopup();

    this.scene.addTween(this.shader, 500, { alpha: 0 }, Phaser.Math.Easing.Linear);
    this.scene.addTween(
      this,
      500,
      { scaleX: 0, scaleY: 0 },
      Phaser.Math.Easing.Back.In,
      () => {
        if (type === 'resume') {
          this.scene.resumeGame();
        }
        else if (type === 'reset') {
          gameData.score = 0;
          gameData.moves = 0;
          gameData.shuffleCounter = gameData.initShuffleCounter;
          this.scene.resetGrid(true);
        }
        else if (type === 'play') {
          this.scene.resetGrid(true);
        }
        else {
          this.scene.cleanUp('Intro');
        }
      }
    );
  }

  starFire() {
    // console.log("flickering", this.x, this.y);
    this.particles = this.scene.add.particles(this.scene.defaultAtlas, 'Cmn_EndStar');
    this.emitter = this.particles.createEmitter({
      x: -50,
      y: -120,
      speedX: { min: -300, max: -100 },
      speedY: { min: -200, max: 200 },
      scale: { start: 0, end: .25 },
      lifespan: Phaser.Math.Between(800, 1000),
      alpha: { min: 0, max: 1 },
      frequency: 50,
    });

    this.particles2 = this.scene.add.particles(this.scene.defaultAtlas, 'Cmn_EndStar');
    this.emitter2 = this.particles2.createEmitter({
      x: 30,
      y: -120,
      speedX: { min: 300, max: 100 },
      speedY: { min: -200, max: 200 },
      scale: { start: 0, end: .25 },
      lifespan: Phaser.Math.Between(800, 1000),
      alpha: { min: 0, max: 1 },
      frequency: 50,
    });

    this.addAt(this.emitter.manager, 1);
    this.addAt(this.emitter2.manager, 1);
  }

  changeFrequency(maxVal = 1, easeFunc = Phaser.Math.Easing.Linear) {
    this.emitter.setFrequency((p, k, t) => easeFunc(maxVal - (maxVal * 2) * Math.abs(t - (maxVal * .5))));
  }

  disablePopup() {
    // console.log("disabling buttons");
    if (this.home) this.home.setEnabled(false);
    if (this.exit) this.exit.setEnabled(false);
    if (this.mute) this.mute.setEnabled(false);
    if (this.soundBtn) this.soundBtn.setEnabled(false);
  }

  enablePopup() {
    // console.log("enabling buttons");
    if (this.home) this.home.setEnabled(true);
    if (this.exit) this.exit.setEnabled(true);
    if (this.mute) this.mute.setEnabled(true);
    if (this.soundBtn) this.soundBtn.setEnabled(true);
  }

  cleanUp() {
    // console.log("cleaning UP");
    if (this.home) this.home.destroy();
    if (this.exit) this.exit.destroy();
    this.bg.destroy();
    this.shader.destroy();
    this.txt.destroy();

    if (this.particles) {
      this.particles.destroy();
      this.particles2.destroy();
    }

    if (this.mute) {
      this.soundBG.destroy();
      this.mute.destroy();
      this.soundBtn.destroy();
    }
  }
}